import React from 'react'
import AllRestaurantsSideBar from "../../sub-components/AllRestaurantsSideBar"

function Test() {
  return (
    <div>

    <section className="breadcrumb-osahan pt-5 pb-5 bg-dark position-relative text-center">
      <h1 className="text-white">Offers Near You</h1>
      <h6 className="text-white-50">Best deals at your favourite restaurants</h6>
    </section>
    <section className="section pt-5 pb-5 products-listing">
      <div className="container">
        <div className="row d-none-m">
          <div className="col-md-12">
            <div className="dropdown float-right">
              <a className="btn btn-outline-info dropdown-toggle btn-sm border-white-btn" href="#" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                Sort by: <span className="text-theme">Distance</span> &nbsp;&nbsp;
              </a>
              <div className="dropdown-menu dropdown-menu-right shadow-sm border-0 ">
                <a className="dropdown-item" href="#">Distance</a>
                <a className="dropdown-item" href="#">No Of Offers</a>
                <a className="dropdown-item" href="#">Rating</a>
              </div>
            </div>
            <h4 className="font-weight-bold mt-0 mb-3">OFFERS <small className="h6 mb-0 ml-2">299 restaurants
              </small>
            </h4>
          </div>
        </div>
        <div className="row">
        <div className="col-md-3">
          <AllRestaurantsSideBar />
          </div>
          <div className="col-md-9">
            <div className="owl-carousel owl-carousel-category owl-theme list-cate-page mb-4">
              <div className="item">
                <div className="osahan-category-item">
                  <a href="#">
                    <img className="img-fluid" src="img/list/1.png" alt="" />
                    <h6>American</h6>
                    <p>156</p>
                  </a>
                </div>
              </div>
              <div className="item">
                <div className="osahan-category-item">
                  <a href="#">
                    <img className="img-fluid" src="img/list/2.png" alt="" />
                    <h6>Pizza</h6>
                    <p>120</p>
                  </a>
                </div>
              </div>
              <div className="item">
                <div className="osahan-category-item">
                  <a href="#">
                    <img className="img-fluid" src="img/list/3.png" alt="" />
                    <h6>Healthy</h6>
                    <p>130</p>
                  </a>
                </div>
              </div>
              <div className="item">
                <div className="osahan-category-item">
                  <a href="#">
                    <img className="img-fluid" src="img/list/4.png" alt="" />
                    <h6>Vegetarian</h6>
                    <p>120</p>
                  </a>
                </div>
              </div>
              <div className="item">
                <div className="osahan-category-item">
                  <a href="#">
                    <img className="img-fluid" src="img/list/5.png" alt="" />
                    <h6>Chinese</h6>
                    <p>111</p>
                  </a>
                </div>
              </div>
              <div className="item">
                <div className="osahan-category-item">
                  <a href="#">
                    <img className="img-fluid" src="img/list/6.png" alt="" />
                    <h6>Hamburgers</h6>
                    <p>958</p>
                  </a>
                </div>
              </div>
              <div className="item">
                <div className="osahan-category-item">
                  <a href="#">
                    <img className="img-fluid" src="img/list/7.png" alt="" />
                    <h6>Dessert</h6>
                    <p>56</p>
                  </a>
                </div>
              </div>
              <div className="item">
                <div className="osahan-category-item">
                  <a href="#">
                    <img className="img-fluid" src="img/list/8.png" alt="" />
                    <h6>Chicken</h6>
                    <p>40</p>
                  </a>
                </div>
              </div>
              <div className="item">
                <div className="osahan-category-item">
                  <a href="#">
                    <img className="img-fluid" src="img/list/9.png" alt="" />
                    <h6>Indian</h6>
                    <p>156</p>
                  </a>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-4 col-sm-6 mb-4 pb-2">
                <div className="list-card bg-white rounded overflow-hidden position-relative shadow-sm">
                  <div className="list-card-image">
                    <div className="star position-absolute"><span className="badge badge-success"><i className="icofont-star" /> 3.1 (300+)</span></div>
                    <div className="favourite-heart text-danger position-absolute"><a href="detail.html"><i className="icofont-heart" /></a></div>
                    <div className="member-plan position-absolute"><span className="badge badge-dark">Promoted</span></div>
                    <a href="detail.html">
                      <img src="img/list/1.png" className="img-fluid item-img" />
                    </a>
                  </div>
                  <div className="p-3 position-relative">
                    <div className="list-card-body">
                      <h6 className="mb-1"><a href="detail.html" className="text-black">World Famous</a></h6>
                      <p className="text-gray mb-3">North Indian • American • Pure veg</p>
                      <p className="text-gray mb-3 time"><span className="bg-light text-dark rounded-sm pl-2 pb-1 pt-1 pr-2"><i className="icofont-wall-clock" /> 20–25 min</span> <span className="float-right text-black-50"> $250 FOR TWO</span></p>
                    </div>
                    <div className="list-card-badge">
                      <span className="badge badge-success">OFFER</span> <small>65% off | Use Coupon OSAHAN50</small>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-4 col-sm-6 mb-4 pb-2">
                <div className="list-card bg-white rounded overflow-hidden position-relative shadow-sm">
                  <div className="list-card-image">
                    <div className="star position-absolute"><span className="badge badge-success"><i className="icofont-star" /> 3.1 (300+)</span></div>
                    <div className="favourite-heart text-danger position-absolute"><a href="detail.html"><i className="icofont-heart" /></a></div>
                    <div className="member-plan position-absolute"><span className="badge badge-dark">Promoted</span></div>
                    <a href="detail.html">
                      <img src="img/list/2.png" className="img-fluid item-img" />
                    </a>
                  </div>
                  <div className="p-3 position-relative">
                    <div className="list-card-body">
                      <h6 className="mb-1"><a href="detail.html" className="text-black">Famous Food</a></h6>
                      <p className="text-gray mb-3">North Indian • Indian • Pure veg</p>
                      <p className="text-gray mb-3 time"><span className="bg-light text-dark rounded-sm pl-2 pb-1 pt-1 pr-2"><i className="icofont-wall-clock" /> 15–25 min</span> <span className="float-right text-black-50"> $250 FOR TWO</span></p>
                    </div>
                    <div className="list-card-badge">
                      <span className="badge badge-danger">OFFER</span> <small>65% off | Use Coupon OSAHAN50</small>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-4 col-sm-6 mb-4 pb-2">
                <div className="list-card bg-white rounded overflow-hidden position-relative shadow-sm">
                  <div className="list-card-image">
                    <div className="star position-absolute"><span className="badge badge-warning"><i className="icofont-star" /> 3.1 (300+)</span></div>
                    <div className="favourite-heart text-danger position-absolute"><a href="detail.html"><i className="icofont-heart" /></a></div>
                    <div className="member-plan position-absolute"><span className="badge badge-dark">Promoted</span></div>
                    <a href="detail.html">
                      <img src="img/list/3.png" className="img-fluid item-img" />
                    </a>
                  </div>
                  <div className="p-3 position-relative">
                    <div className="list-card-body">
                      <h6 className="mb-1"><a href="detail.html" className="text-black">Bite Me Sandwiches</a></h6>
                      <p className="text-gray mb-3">North Indian • Indian • Pure veg</p>
                      <p className="text-gray mb-3 time"><span className="bg-light text-dark rounded-sm pl-2 pb-1 pt-1 pr-2"><i className="icofont-wall-clock" /> 15–25 min</span> <span className="float-right text-black-50"> $100 FOR TWO</span></p>
                    </div>
                    <div className="list-card-badge">
                      <span className="badge badge-danger">OFFER</span> <small>65% off | Use Coupon OSAHAN50</small>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-4 col-sm-6 mb-4 pb-2">
                <div className="list-card bg-white rounded overflow-hidden position-relative shadow-sm">
                  <div className="list-card-image">
                    <div className="star position-absolute"><span className="badge badge-success"><i className="icofont-star" /> 3.1 (300+)</span></div>
                    <div className="favourite-heart text-danger position-absolute"><a href="detail.html"><i className="icofont-heart" /></a></div>
                    <div className="member-plan position-absolute"><span className="badge badge-dark">Promoted</span></div>
                    <a href="detail.html">
                      <img src="img/list/4.png" className="img-fluid item-img" />
                    </a>
                  </div>
                  <div className="p-3 position-relative">
                    <div className="list-card-body">
                      <h6 className="mb-1"><a href="detail.html" className="text-black">Famous Dave's Bar-B-Que
                        </a>
                      </h6>
                      <p className="text-gray mb-3">Vegetarian • Indian • Pure veg</p>
                      <p className="text-gray mb-3 time"><span className="bg-light text-dark rounded-sm pl-2 pb-1 pt-1 pr-2"><i className="icofont-wall-clock" /> 15–30 min</span> <span className="float-right text-black-50"> $350 FOR TWO</span></p>
                    </div>
                    <div className="list-card-badge">
                      <span className="badge badge-danger">OFFER</span> <small>65% off | Use Coupon OSAHAN50</small>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-4 col-sm-6 mb-4 pb-2">
                <div className="list-card bg-white rounded overflow-hidden position-relative shadow-sm">
                  <div className="list-card-image">
                    <div className="star position-absolute"><span className="badge badge-success"><i className="icofont-star" /> 3.1 (300+)</span></div>
                    <div className="favourite-heart text-danger position-absolute"><a href="detail.html"><i className="icofont-heart" /></a></div>
                    <div className="member-plan position-absolute"><span className="badge badge-dark">Promoted</span></div>
                    <a href="detail.html">
                      <img src="img/list/5.png" className="img-fluid item-img" />
                    </a>
                  </div>
                  <div className="p-3 position-relative">
                    <div className="list-card-body">
                      <h6 className="mb-1"><a href="detail.html" className="text-black">Thai Famous Cuisine</a></h6>
                      <p className="text-gray mb-3">North Indian • Indian • Pure veg</p>
                      <p className="text-gray mb-3 time"><span className="bg-light text-dark rounded-sm pl-2 pb-1 pt-1 pr-2"><i className="icofont-wall-clock" /> 30–35 min</span> <span className="float-right text-black-50"> $250 FOR TWO</span></p>
                    </div>
                    <div className="list-card-badge">
                      <span className="badge badge-success">OFFER</span> <small>65% off | Use Coupon OSAHAN50</small>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-4 col-sm-6 mb-4 pb-2">
                <div className="list-card bg-white rounded overflow-hidden position-relative shadow-sm">
                  <div className="list-card-image">
                    <div className="star position-absolute"><span className="badge badge-success"><i className="icofont-star" /> 3.1 (300+)</span></div>
                    <div className="favourite-heart text-danger position-absolute"><a href="detail.html"><i className="icofont-heart" /></a></div>
                    <div className="member-plan position-absolute"><span className="badge badge-danger">Promoted</span></div>
                    <a href="detail.html">
                      <img src="img/list/6.png" className="img-fluid item-img" />
                    </a>
                  </div>
                  <div className="p-3 position-relative">
                    <div className="list-card-body">
                      <h6 className="mb-1"><a href="detail.html" className="text-black">The osahan Restaurant
                        </a>
                      </h6>
                      <p className="text-gray mb-3">North • Hamburgers • Pure veg</p>
                      <p className="text-gray mb-3 time"><span className="bg-light text-dark rounded-sm pl-2 pb-1 pt-1 pr-2"><i className="icofont-wall-clock" /> 15–25 min</span> <span className="float-right text-black-50"> $500 FOR TWO</span></p>
                    </div>
                    <div className="list-card-badge">
                      <span className="badge badge-danger">OFFER</span> <small>65% off | Use Coupon OSAHAN50</small>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-4 col-sm-6 mb-4 pb-2">
                <div className="list-card bg-white rounded overflow-hidden position-relative shadow-sm">
                  <div className="list-card-image">
                    <div className="star position-absolute"><span className="badge badge-warning"><i className="icofont-star" /> 3.1 (300+)</span></div>
                    <div className="favourite-heart text-danger position-absolute"><a href="detail.html"><i className="icofont-heart" /></a></div>
                    <div className="member-plan position-absolute"><span className="badge badge-dark">Promoted</span></div>
                    <a href="detail.html">
                      <img src="img/list/7.png" className="img-fluid item-img" />
                    </a>
                  </div>
                  <div className="p-3 position-relative">
                    <div className="list-card-body">
                      <h6 className="mb-1"><a href="detail.html" className="text-black">Stan's Restaurant
                        </a>
                      </h6>
                      <p className="text-gray mb-3">North Indian • Indian • Pure veg</p>
                      <p className="text-gray mb-3 time"><span className="bg-light text-dark rounded-sm pl-2 pb-1 pt-1 pr-2"><i className="icofont-wall-clock" /> 15–25 min</span> <span className="float-right text-black-50"> $250 FOR TWO</span></p>
                    </div>
                    <div className="list-card-badge">
                      <span className="badge badge-danger">OFFER</span> <small>65% off | Use Coupon OSAHAN50</small>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-4 col-sm-6 mb-4 pb-2">
                <div className="list-card bg-white rounded overflow-hidden position-relative shadow-sm">
                  <div className="list-card-image">
                    <div className="star position-absolute"><span className="badge badge-success"><i className="icofont-star" /> 3.1 (300+)</span></div>
                    <div className="favourite-heart text-danger position-absolute"><a href="detail.html"><i className="icofont-heart" /></a></div>
                    <div className="member-plan position-absolute"><span className="badge badge-dark">Promoted</span></div>
                    <a href="detail.html">
                      <img src="img/list/8.png" className="img-fluid item-img" />
                    </a>
                  </div>
                  <div className="p-3 position-relative">
                    <div className="list-card-body">
                      <h6 className="mb-1"><a href="detail.html" className="text-black">Polo Lounge
                        </a>
                      </h6>
                      <p className="text-gray mb-3">North Indian • Indian • Pure veg</p>
                      <p className="text-gray mb-3 time"><span className="bg-light text-dark rounded-sm pl-2 pb-1 pt-1 pr-2"><i className="icofont-wall-clock" /> 15–25 min</span> <span className="float-right text-black-50"> $250 FOR TWO</span></p>
                    </div>
                    <div className="list-card-badge">
                      <span className="badge badge-danger">OFFER</span> <small>65% off | Use Coupon OSAHAN50</small>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-4 col-sm-6 mb-4 pb-2">
                <div className="list-card bg-white rounded overflow-hidden position-relative shadow-sm">
                  <div className="list-card-image">
                    <div className="star position-absolute"><span className="badge badge-success"><i className="icofont-star" /> 3.1 (300+)</span></div>
                    <div className="favourite-heart text-danger position-absolute"><a href="detail.html"><i className="icofont-heart" /></a></div>
                    <div className="member-plan position-absolute"><span className="badge badge-dark">Promoted</span></div>
                    <a href="detail.html">
                      <img src="img/list/9.png" className="img-fluid item-img" />
                    </a>
                  </div>
                  <div className="p-3 position-relative">
                    <div className="list-card-body">
                      <h6 className="mb-1"><a href="detail.html" className="text-black">Jack Fry's
                        </a>
                      </h6>
                      <p className="text-gray mb-3">North Indian • Indian • Pure veg</p>
                      <p className="text-gray mb-3 time"><span className="bg-light text-dark rounded-sm pl-2 pb-1 pt-1 pr-2"><i className="icofont-wall-clock" /> 15–25 min</span> <span className="float-right text-black-50"> $250 FOR TWO</span></p>
                    </div>
                    <div className="list-card-badge">
                      <span className="badge badge-danger">OFFER</span> <small>65% off | Use Coupon OSAHAN50</small>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-12 text-center load-more">
                <button className="btn btn-primary" type="button" disabled>
                  <span className="spinner-grow spinner-grow-sm" role="status" aria-hidden="true" />
                  Loading...
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
  )
}

export default Test